import { makeAutoObservable } from "mobx";
import { DataTableStore } from "./DataTableStore";
import { onError } from "@/utils/onError";
import { FiltersStore } from "./FiltersStore";
import { SearchFilter } from "@/components/filters";
export class VehicleModelsStore {
    constructor(vehicleModelService) {
        this.vehicleModelService = vehicleModelService;
        this.loading = false;
        this.initializeVehicleModelFilters = () => {
            const filterItems = [
                // Search Filter
                {
                    id: "search-filter",
                    Cmp: SearchFilter,
                    props: {
                        name: "search",
                        label: "Поиск",
                        placeholder: "Поиск по модели, производителю...",
                        allowClear: true,
                        showSearchIcon: true,
                        onChange: (value) => this.filtersStore.updateFilter("search", value),
                    },
                    visible: true,
                    order: 4,
                },
            ];
            this.filtersStore.setFilterItems(filterItems);
        };
        this.dataTable = new DataTableStore({
            defaultFilters: { search: "" },
            dataLoader: {
                loadData: (params) => this.loadVehicleModels(params),
            },
        });
        this.filtersStore = new FiltersStore();
        this.initializeVehicleModelFilters();
        makeAutoObservable(this);
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async loadVehicleModels(params) {
        try {
            // Получаем данные через сервис с учетом параметров
            const result = await this.vehicleModelService.getVehicleModelsWithParams({
                page: params.page,
                pageSize: params.pageSize,
                filters: params.filters,
                sorters: params.sorters,
            });
            return {
                data: result.data,
                total: result.total,
                page: params.page,
                pageSize: params.pageSize,
            };
        }
        catch (error) {
            throw error;
        }
    }
    async deleteVehicleModel(id) {
        this.setLoading(true);
        try {
            await this.vehicleModelService.deleteVehicleModel(id);
            await this.dataTable.refresh();
        }
        catch (error) {
            onError(error, "Error deleting vehicle model");
        }
        finally {
            this.setLoading(false);
        }
    }
}
